/**
 * Content Block Types - Must match backend schema
 */
export enum ContentBlockType {
  HEADING = 'heading',
  PARAGRAPH = 'paragraph',
  CODE = 'code',
  IMAGE = 'image',
  CALLOUT = 'callout',
  LIST = 'list',
  QUOTE = 'quote',
  DIVIDER = 'divider',
  SPACER = 'spacer',
  TABLE = 'table',
  VIDEO = 'video',
  LINK = 'link',
}

export enum CalloutVariant {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
  TIP = 'tip',
  NOTE = 'note',
}

export enum ListType {
  UNORDERED = 'unordered',
  ORDERED = 'ordered',
}

export interface CodeVariant {
  language: string;
  code: string;
  fileName?: string;
}

export interface CodeBlockConfig {
  language: string;
  code: string;
  fileName?: string;
  highlightLines?: number[];
  showLineNumbers?: boolean;
  variants?: CodeVariant[];
}

export interface ImageConfig {
  url: string;
  alt?: string;
  caption?: string;
  fullWidth?: boolean;
}

export interface TableConfig {
  headers: string[];
  rows: string[][];
  striped?: boolean;
}

export interface ContentBlock {
  type: ContentBlockType;
  content?: string;
  level?: number; // For headings (1-6)
  codeConfig?: CodeBlockConfig;
  imageConfig?: ImageConfig;
  calloutVariant?: CalloutVariant;
  listType?: ListType;
  listItems?: string[];
  tableConfig?: TableConfig;
  videoUrl?: string;
  linkUrl?: string;
  linkText?: string;
  metadata?: Record<string, any>;
  order: number;
}

export interface ContentPage {
  id: string;
  slug: string;
  title: string;
  description?: string;
  blocks: ContentBlock[];
  category: string;
  subcategory?: string;
  tags: string[];
  author?: {
    name: string;
    fullName: string;
    avatar?: string;
  };
  lastUpdated?: string;
  readTime?: string;
  status: 'draft' | 'published' | 'archived';
  version: number;
  metadata?: {
    difficulty?: 'beginner' | 'intermediate' | 'advanced';
    estimatedTime?: string;
    prerequisites?: string[];
    relatedPages?: string[];
    [key: string]: any;
  };
  viewCount: number;
  likeCount: number;
  averageRating: number; // Cached average rating (0-10)
  ratingCount: number; // Total number of ratings
  isActive: boolean;
  publishedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface QueryContentPagesParams {
  category?: string;
  subcategory?: string;
  tags?: string[];
  status?: 'draft' | 'published' | 'archived';
  search?: string;
  page?: number;
  limit?: number;
}

export interface QueryContentPagesResponse {
  pages: ContentPage[];
  total: number;
  page: number;
  limit: number;
}

